import { render } from "./TwelveFooter.vue?vue&type=template&id=20ff2263"
import script from "./TwelveFooter.vue?vue&type=script&lang=js"
export * from "./TwelveFooter.vue?vue&type=script&lang=js"
script.render = render

export default script